<template>
  <FreeBottomSheet
    :name="bottomSheet.name"
    style="--free-ui-bottom-sheet-min-height: calc(100vh - 60px)"
    @onOpen="onOpen"
  >
    <template #header>
      <div
        v-if="destCity"
        class="flex items-center justify-between px-4 pb-2 pt-4"
      >
        <div
          class="text-text-neutral-primary text-base font-medium"
        >
          {{ getMappedCityNameWithEmoji(destCity) }}
        </div>
        <FreeCloseButton @click="bottomSheet.hide" />
      </div>
    </template>
    <HotOffersRoutesContent :routes="hotRoutes" @onCardClick="toSERP" />
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { FreeBottomSheet, FreeCloseButton } from 'freedom-shared';

  import { saveCitiesFromOffer } from '@/features/offers/model';

  import { amplitudeEventsConfig } from '@/shared/config';
  import { analyticsEventsLib } from '@/shared/lib';

  import { getMappedCityNameWithEmoji } from '../lib';
  import {
    useHotOffers,
    useHotOffersRoutesBottomSheetController,
  } from '../model';

  import { HotOffersRoutesContent } from '.';

  const { hotRoutes, changeDestCityCode, hotCities, destCityCode } =
    useHotOffers();

  const bottomSheet = useHotOffersRoutesBottomSheetController();

  const router = useRouter();

  const destCities = computed(
    () =>
      new Map(
        hotCities.value.map(city => [
          city.destination.city.code,
          city.destination.city,
        ]),
      ),
  );

  const destCity = computed(() =>
    destCityCode.value ? destCities.value.get(destCityCode.value) : null,
  );

  function toSERP(routeIdx: number) {
    const selectedRoute = hotRoutes.value[routeIdx];
    analyticsEventsLib.hotOffersSearchClick({
      origCityCode: selectedRoute.origin.city.code,
      destCityCode: selectedRoute.destination.city.code,
      date: selectedRoute.dep_date,
      price: selectedRoute.price.amount,
    });
    saveCitiesFromOffer(selectedRoute);
    router.push({
      name: 'OffersResults',
      params: {
        hashCode: selectedRoute.search_query,
        source: amplitudeEventsConfig.SERP_OPEN_SOURCE.HOT_OFFERS,
      },
    });
  }

  function onOpen() {
    const { destCityCode } = bottomSheet.params();
    changeDestCityCode(destCityCode);
  }
</script>
